import React from 'react';
import { Switch as SwitchAntd } from 'antd';
import classNames from 'classnames';

const Switch = ({ className, checked, onChange, onClick, label, disabled, loading }) => {
  return (
    <div className={className}>
      <SwitchAntd
        size="small"
        checked={checked}
        onChange={onChange}
        disabled={disabled && disabled}
        loading={loading && loading}
      />
      <label
        className={classNames('inline-block align-middle ml-2 cursor-pointer', { '!cursor-not-allowed': disabled })}
        onClick={onClick}
      >
        {label}
      </label>
    </div>
  );
};

export default Switch;
